/**
 * autocomplete
 *  - initial implementation: global search box
 */

'use strict';
const result = require('lodash.result');
const uniqBy = require('lodash.uniqby');
const $ = require('dibs-jquery-shim');
const SV = require('server-vars');
const verticals = require('dibs-vertical-helpers');
const $headerSearch = $('#globalSearchBox');
const $toggleNavLink = $('.toggle-nav-link');
const baseDomain = require('../utils/baseDomain');
const mobileCheck = require('bunsen/helpers/mobileCheck');
const queryService = require('../modules/queryService');
const tracking = require('dibs-tracking');
const calloutHelper = require('components/Callout/calloutHelper');

// todo: server should expose this to client -- get from global_nav model
const $headerSearchHeight = $headerSearch.height();
const autoCompleteCache = {};
const hilightRegExpCache = {};
let dibsAutoCompleteWidget;
let autoCompleteOptions;
let DAC;

let trimRows;
let processTerm;
let hilight;
let mungeCreators;
let munge;
let getUrl;

require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.core');
require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.widget');
require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.position');
require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.menu');
require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.autocomplete');
require('jquery-operator');

/**
 * @description Returns all 'top search' results (only 6 are returned). Returns only top 6 dealer vertical results.
 * @param {Array} rows
 * @return {Array}
 */
trimRows = function (rows) {
    const max = 3;
    let count = 0;

    return rows.filter(item => {
        if (item.vert === 'top') {
            return true;
        } else if (count < max) {
            count++;
            return true;
        }
        return false;
    });
};

/**
 * @description Returns term stripped of
 * @param {String} term
 * @return {String}
 */
processTerm = function (term) {
    /**
     * Matches characters other than
     *      1. alpha-numeric
     *      2. spaces
     *      3. &
     *      5. '
     *      6. -
     *      7. +
     * @type {RegExp}
     */
    const regex = /[^a-zA-Z\d\s&'\-\+:]/gi;

    term = (term + '').trim().replace(regex, '');
    return term.replace(/\s{2,}/g, ' ');
};

/**
 * Handles the munge-ing for creator rows
 * @param item the object containing the creator match returned from the server
 * @param search the searched term
 * @returns {*}
 */
mungeCreators = function (item, search) {
    let first;
    let last;
    let literal;
    if (item.vert === 'furniture') {
        item.value = item.n;
    } else if (item.vert === 'art') {
        //the query checks for last and first, so we can assume they exist
        item.value = item.fn + ' ' + item.ln;
    } else if (item.vert === 'jewelry' || item.vert === 'fashion') {
        first = item.fn;
        last = item.ln;
        literal = item.n;
        if (first && last) {
            item.value = first + ' ' + last;
        } else if (literal) {
            item.value = literal;
        }
    }
    item.category = 'creator';
    item.label = hilight(item, search);
    return item;
};

/**
 *
 * @param {Object} item Search suggestion item
 * @param {String} search The searched term
 * @return {String}
 * @private
 */
hilight = function (item, search) {
    const specialCharacters = $('<div>').html(item.value);    //convert html special characters
    let regex;

    item.value = specialCharacters.text();

    if (search in hilightRegExpCache) {
        regex = hilightRegExpCache[search];
    } else {
        hilightRegExpCache[search] = regex = search.split('').map(character => {
            return '(' + character + '\\W?)';
        }).join('');
    }

    return (item.value + '').replace(new RegExp(regex, 'gi'), function (match) {
        return '<em>' + match + '</em>';
    });
};

/**
 * @description Processes query service result into a form jquery.ui.autocomplete likes
 * @param {Array} rows query service rows returned from server
 * @param {String} search The searched term
 * @return {Array}
 * @private
 */
munge = function (rows, search) {
    const abbreviationMap = Object.assign({}, { top: 'top' }, verticals);

    // remove duplicates based on n
    rows = uniqBy(rows, 'n');
    rows = trimRows(rows);

    return rows.map(item => {
        item.vert = abbreviationMap[item.vert];
        if (item.cat === 'c') {
            item = mungeCreators(item, search);
        } else {
            item.value = item.n;
            item.category = (item.vert === 'top' ? item.vert : 'dealer');
            item.label = hilight(item, search);
        }
        return item;
    });
};

/**
 *
 * @param item
 * @returns {*}
 */
getUrl = function (item) {

    function handleCategory(category) {
        const trackingValue = `/?search=${('' + item.key).replace(/-/g, '+')}`;
        let url = `/${category}/${item.key}`;
        if (category !== 'dealers') {
            url += `/${item.vert}`;
        }
        return url + trackingValue;
    }

    const fn = {
        dealer() {
            // keep as `dealers` since that is apart of the url
            return handleCategory('dealers');
        },

        creator() {
            // keep as `creators` since that is apart of the url
            return handleCategory('creators');
        },

        // 'top' as in 'top searches'
        top() {
            return '/search/?q=' + ('' + item.value).replace(/ /g, '+');
        }
    };

    // return 'top' URL if there is an empty 'key' value, which is required for the other factories
    // top defaults to searching for the item value`
    return (item.key !== '' && typeof fn[item.category] === 'function') ?
        fn[item.category]() : fn.top();
};

/**
 *
 * CREATE CUSTOM dac (DIBS AUTO-COMPLETE) WIDGET
 *
 */
dibsAutoCompleteWidget = {
    // used for redirecting FINDING-871
    baseUrl() {
        return SV.get('settings.siteProtocol') + '://' + baseDomain();
    },

    menuHeight() {
        return this.menu.element.height() + $headerSearchHeight + 20;
    },

    _categoryItem(category, extraClass) {
        const klass = 'suggestion-category-item' + (extraClass ? ' ' + extraClass : '');
        let label;

        switch (category) {
            case 'top':
                label = 'Popular Searches';
                break;
            case 'creator':
                label = 'Creators';
                break;
            default:
                label = 'Dealers';
                break;
        }

        return $('<li/>')
            .addClass(klass)
            .text(label);
    },

    showTriangle() {
        const menuZindex = parseInt(this.menu.element.css('z-index'), 10);

        if (this.options.triangle) {
            this.options.triangle
                .css('z-index', menuZindex + 1)
                .addClass('is-showing');
        }
    },

    hideTriangle() {
        if (this.options.triangle) {
            this.options.triangle.removeClass('is-showing');
        }
    },

    inFlyout() {
        return $toggleNavLink.css('display') === 'block';
    },

    _cleanStr(str) {
        return $('<div>' + str + '</div>').text();
    },

    _textLabel(item) {
        return this._cleanStr(this._getLabel(item));
    },

    _getLabel: function (item) {
        return '<span class="suggest-label">' + item.label + '</span>';
    },

    _renderMenu(ul, items) {
        let currentCategory = '';

        this.menu.element.addClass('dibs-autocomplete');

        if (!this.inFlyout()) {
            this.showTriangle();
        }

        items.forEach(item => {
            const klass = currentCategory === '' ? 'is-first' : null;

            if (item.category !== currentCategory) {
                ul.append(this._categoryItem(item.category, klass));
                currentCategory = item.category;
            }
            this._renderItemData(ul, item);
        });
    },

    _renderItem(ul, item) {
        const url = getUrl(item);
        const fullUrl = result(this, 'baseUrl') + url;
        let li;
        let a;

        li = $('<li>').addClass('search-suggest-item');
        a = $('<a>')
            .addClass('search-suggest-link')
            .attr('href', fullUrl)
            .html(this._getLabel(item));

        return li.append(a).appendTo(ul);
    }
};

$.widget('custom.dac', $.ui.autocomplete, dibsAutoCompleteWidget);

/**
 * DAC OPTIONS OBJECT
 * @type {{triangle: (*|HTMLElement), context: (*|HTMLElement), appendTo: (*|HTMLElement), minLength: number, select: Function, close: Function, open: Function, source: Function}}
 */
autoCompleteOptions = {
    triangle: $('.triangle', $headerSearch),
    context:  $headerSearch,
    appendTo: $('.search-suggest', $headerSearch),
    minLength: 2,

    select(e, ui) {
        const dac = $(this).data('customDac');
        const creator = ui.item.category === 'creator';
        const dealer = !creator && ui.item.key !== 'search';
        const label = dac._textLabel(ui.item);
        let trackObj;
        let action;
        let url;

        if (dealer) {
            action = 'dealer selected';
        } else if (creator) {
            action = 'creator selected';
        } else {
            action = ui.item.key;
        }

        trackObj = {
            category: 'search auto-complete selected',
            action: action,
            label: dac._cleanStr(label.toLowerCase())
        };

        url = getUrl(ui.item);

        $(e.target).val(ui.item.value);
        tracking.trackEvent(trackObj);
        calloutHelper.enableFollowSearchCallout();

        // the following set of lines taken from now removed method:
        // tracking.handleTrackingEventInfo
        e.preventDefault();
        e.stopImmediatePropagation();
        setTimeout(function () {
            global.location.href = url;
        }, 100);
        return false;
    },

    /**
     * Set position in the response event handler, it's the event that happens just before the menu shows
     * http://api.jqueryui.com/autocomplete/#event-response
     */
    response() {
        const dac = $(this).data('customDac');
        const pos = {
            my: 'right top',
            at: 'right bottom+8',
            of: $headerSearch
        };
        const flyoutPos = {
            my: 'left top',
            at: 'left bottom',
            of: $(this).parents('.search-box')
        };

        $(this).dac('option', 'position', (dac.inFlyout() ? flyoutPos : pos));
    },

    close() {
        $headerSearch.css({ height: 'auto' });
        $(this).data('customDac').hideTriangle();

        if (mobileCheck.iPad()) {
            $('#searchSuggestions').off('touchstart.iPadSelectSearchResult');
        }

        // dibs.__dacStatus = 'closed';
        // dacStatus = 'closed';
    },

    open() {
        const dac = $(this).data('customDac');

        if (dac.inFlyout()) {
            $headerSearch.css({ height: dac.menuHeight() + 'px' });
        }

        // FINDING-6034 : Can't click on Popular Search Result in Search Suggestions
        // jquery.ui.menu listens only for clicks on menu items (not touchevents) so manually
        // triggering a click event here (And turning it off when the search suggestion are closed)
        if (mobileCheck.iPad()) {
            $('#searchSuggestions')
                .on('touchstart.iPadSelectSearchResult', function (e) {
                    $(e.target).closest('.ui-menu-item > a').click();
                    return false;
                });
        }

        // dibs.__dacStatus = 'open';
        // dacStatus = 'open';
    },

    source(request, response) {
        const search = processTerm(request.term);
        const query = {
            qs: '% ' + search + '%',
            q: search + '%',
            type: 'composed'
        };

        if (search in autoCompleteCache) {
            response(autoCompleteCache[search]);
            return;
        }

        queryService.json('search_suggestions_all', query)
            .done(function (rows) {
                rows = munge(rows, search);
                autoCompleteCache[search] = rows;
                response(rows);
            })
            .fail(function () {
                response([]);
            });
    }
};

/**
 * Create instance of the dac on search-box-input (not on iphone or ipod touch)...
 */

// FINDING-1767 - turn on autocomplete for legacy pages
// if (dibs.settings && dibs.settings.isLegacy) {
// return false;
// }

if (mobileCheck.iPad() || !mobileCheck.iOS()) {
    DAC = $('.search-box-input', $headerSearch)
        .dac(autoCompleteOptions)
        .on('focus', function () {
            // http://stackoverflow.com/questions/11168446/jquery-autocomplete-trigger-dropdown-on-inputfocus
            $(this).dac('search');
        });
}

$.subscribe('nav:search-toggled', function (e, focus) {
    if (!SV.settings.isLegacy && DAC && focus !== false) {
        DAC.focus();
    }
});

$.subscribe('nav:state-changed', function (e, state) {
    if (!SV.settings.isLegacy && DAC && state === 'full') {
        // close the autocomplete when nav state changes from persistent to full
        DAC.dac('close');
    }
});

$(window).on('resize orientationchange', function (e) {
    if (!SV.settings.isLegacy && DAC) {
        // close the autocomplete when resize occurs (resets position, hides triangle, etc)
        DAC.dac('close');

        // ONLY BLUR ON ORIENTATION CHANGES
        // FIXES ISSUE WITH SCREEN NOT REDRAWING PROPERLY WHEN THE TEXT FIELD IS FOCUSED.
        if (e.type === 'orientationchange') {
            DAC.blur();
        }
    }
});

module.exports = {
    trimRows,
    processTerm,
    munge,
    hilight,
    getUrl
};



// WEBPACK FOOTER //
// ./assets/js/global/modules/searchSuggestions.es.js